import React from 'react';
import { X, BookOpen } from 'lucide-react';

// DeepDiveModal组件的Props接口
interface DeepDiveModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  content: string;
  knowledgeBlocks?: (string | null)[];
}

/**
 * DeepDiveModal组件 - 深度指导模态窗口
 * 显示详细的专业指导内容和相关知识块
 */
const DeepDiveModal: React.FC<DeepDiveModalProps> = ({
  isOpen,
  onClose,
  title,
  content,
  knowledgeBlocks = []
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      {/* 背景遮罩 */}
      <div 
        className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm transition-opacity"
        onClick={onClose}
      />
      
      {/* 模态窗口内容 */}
      <div className="flex min-h-full items-center justify-center p-4">
        <div className="relative w-full max-w-2xl bg-white rounded-2xl shadow-2xl transform transition-all">
          {/* 头部 */}
          <div className="flex items-center justify-between p-6 border-b border-gray-200">
            <div className="flex items-center space-x-3">
              <div className="p-2 rounded-full bg-blue-100">
                <BookOpen className="w-6 h-6 text-blue-600" />
              </div>
              <h2 className="text-xl font-bold text-gray-900">
                深度指导 - {title}
              </h2>
            </div>
            <button
              onClick={onClose}
              className="p-2 rounded-full hover:bg-gray-100 transition-colors"
            >
              <X className="w-5 h-5 text-gray-500" />
            </button>
          </div>
          
          {/* 内容区域 */}
          <div className="p-6 max-h-96 overflow-y-auto">
            <div className="space-y-4">
              {/* 主要内容 */}
              <div>
                <h3 className="text-lg font-semibold text-gray-800 mb-3">
                  专业背景信息
                </h3>
                <div className="text-gray-700 leading-relaxed whitespace-pre-wrap">
                  {content}
                </div>
              </div>
              
            </div>
          </div>
          
          {/* 底部操作 */}
          <div className="flex justify-end p-6 border-t border-gray-200">
            <button
              onClick={onClose}
              className="px-6 py-2 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors"
            >
              关闭
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeepDiveModal;